import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

import { Container, Grid, LinearProgress } from "@mui/material";
import { PageHeader } from "../../common";
import { FetchContext, NavContext } from "../../contexts";
import { CompetenzaContext, CompetenzaProvider } from "./CompetenzaContext";
import { AssignmentDialog, CompetenzaDetails } from "./components";

const PageContent = (props) => {
    const { user } = useContext(FetchContext);

    const { addBreadcrumbToken, setBread, goBack } = useContext(NavContext);

    const {
        state,
        setState,

        isLoadingCompetenza,
        getCompetenzaAsync,

        isUpdatingCompetenza,
        updateCompetenzaAsync,

        isAddingCompetenza,
        addCompetenzaAsync,

        isLoadingTipiUffici,
        getTipiUfficiAsync,

        isLoadingUffici,
        getUfficiAsync,

        isLoadingComuni,
        getComuniAsync,

        isAssigningCompetenze,
        assignCompetenzeAsync,

        isLoadingRegioni,
        getRegioniAsync,

        isLoadingProvince,
        getProvinceAsync,
    } = useContext(CompetenzaContext);

    const {
        competenza,

        tipiUffici,
    } = state;

    const { competenzaId } = useParams();

    const [openImportDialog, setOpenImportDialog] = useState(false);

    const formRef = useRef();
    const saveClickHandler = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const competenzaDetailsFormActionClickHandler = async (action, data) => {
        switch (action) {
            case "Submit":
                if (competenza) {
                    if (window.confirm("Confermare il salvataggio?")) {
                        await updateCompetenzaAsync(competenzaId, data);
                    }
                } else {
                    if (window.confirm("Confermare l'inserimento?")) {
                        await addCompetenzaAsync(data);
                        goBack();
                    }
                }
                break;
            case "MassiveAssignment":
                setOpenImportDialog(true);
                break;
            default:
                break;
        }
    };

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(
            isLoadingCompetenza ||
            isUpdatingCompetenza ||
            isAddingCompetenza ||
            isAssigningCompetenze
        );
    }, [
        isLoadingCompetenza,
        isUpdatingCompetenza,
        isAddingCompetenza,
        isAssigningCompetenze,
    ]);

    useEffect(() => {
        if (competenza) {
            addBreadcrumbToken(competenza.tipoUfficio?.nome);
            getComuniAsync();
            getRegioniAsync();
            getProvinceAsync();
        }
    }, [competenza]);

    useEffect(() => {
        if (competenza && tipiUffici)
            getUfficiAsync([...getTipiUfficiTreeIds(tipiUffici.result, competenza.tipoUfficioId), competenza.tipoUfficioId]);
    }, [competenza, tipiUffici])

    const getTipiUfficiTreeIds = (tipi, padreId) => {
        let result = [];
        let ids = tipi.filter(x => x.padreId == padreId).map(x => x.id);
        ids.forEach(id => {
            result = [...result, ...getTipiUfficiTreeIds(tipi, id), id];
        });
        return result;
    }

    useEffect(() => {
        if (user) {
            if (!competenzaId) {
                addBreadcrumbToken("Aggiungi");
            } else getCompetenzaAsync(competenzaId);
            getTipiUfficiAsync();
        }
    }, [user]);

    return (
        <>
            <Container>
                {isLoading && <LinearProgress />}
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            save
                            onSaveClick={saveClickHandler}
                            disabled={isLoading}
                            title="Competenza"
                            subtitle="Gestisci la competenza"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <CompetenzaDetails
                            onActionClick={competenzaDetailsFormActionClickHandler}
                            disabled={isLoading}
                            formRef={formRef}
                        />
                    </Grid>
                </Grid>
            </Container>
            <AssignmentDialog
                open={openImportDialog}
                handleClose={() => setOpenImportDialog(false)}
                handleSubmit={(
                    ufficio,
                    comuni = null,
                    regioneId = null,
                    provinciaId = null,
                    valid = false,
                    invalid = false,
                    all = false
                ) => {
                    if (ufficio == null) return;

                    if (window.confirm("Confermare il salvataggio?")) {
                        assignCompetenzeAsync(
                            competenzaId,
                            ufficio.ufficioId,
                            comuni?.map((x) => x.comuneId),
                            regioneId,
                            provinciaId,
                            valid,
                            invalid,
                            all
                        );
                        setOpenImportDialog(false);
                    }
                }}
            />
        </>
    );
};

export const CompetenzaPage = () => {
    return (
        <CompetenzaProvider>
            <PageContent />
        </CompetenzaProvider>
    );
};
